module.exports = __webpack_public_path__ + "static/armor-of-shadows-9a47427069b1e58bde4c0aec5756315c.webp";